<template>
  <Dialog
    :title="`Switch to ${formatMode(transition.to)}`"
    @close="$emit('close')"
  >
    <template #callouts>
      <Callout.Root v-if="transition.detail === 'clear_body'" variant="warning">
        All of your existing work will be lost upon switching.
      </Callout.Root>
      <Callout.Root
        v-if="transition.detail === 'html_comments'"
        variant="warning"
      >
        Your HTML comments will be lost upon switching.
      </Callout.Root>
    </template>

    <template #actions>
      <ActionButton text="Switch" variant="primary" @click="handleConfirm" />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import ActionButton from "@/components/utilities/ActionButton.vue";
import Callout from "@/design_system/Callout";
import Dialog from "@/design_system/shared/Dialog/Dialog.vue";
import type { EditorMode } from "@/types/email";

export interface ModeTransition {
  from: EditorMode;
  to: EditorMode;
  detail: "html_comments" | "clear_body";
}

const emit = defineEmits<{
  close: [];
  switch: [transition: ModeTransition];
}>();

const props = defineProps<{
  transition: ModeTransition;
}>();

const formatMode = (mode: EditorMode) => {
  switch (mode) {
    case "fancy":
      return `Fancy mode`;
    case "naked":
      return `Naked mode`;
    case "plaintext":
      return `Markdown mode`;
  }
};

const handleConfirm = () => {
  emit("switch", props.transition);
};
</script>
